var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "panoramica-status-header",
      class: [
        _vm.headerClass,
        {
          "panoramica-status-header--lineare":
            _vm.mode_poker ||
            _vm.mode_selvaggia ||
            _vm.mode_bustachiusa ||
            _vm.mode_assegna,
        },
      ],
    },
    [
      _c("div", { staticClass: "panoramica-status-main" }, [
        _c("div", { staticClass: "panoramica-status-log-area" }, [
          _c(
            "div",
            { staticClass: "panoramica-status-log" },
            [
              _vm.astaLogsLast
                ? _c("asta-log", {
                    attrs: { small: "", log: _vm.astaLogsLast },
                  })
                : _c("div", { staticClass: "panoramica-status-log-empty" }, [
                    _vm._v("Registro Eventi"),
                  ]),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticClass: "ml-1 white--text",
                  attrs: { "x-small": "", icon: "", outlined: "" },
                  on: { click: _vm.showAstaLogs },
                },
                [
                  _c("v-icon", { attrs: { small: "" } }, [
                    _vm._v("more_horiz"),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "panoramica-status-center" },
          [
            _vm.calciatoreInAsta
              ? _c("calciatore-battuto", {
                  staticClass: "panoramica-status-calciatore",
                  attrs: { id: _vm.calciatoreInAsta, large: "" },
                })
              : _vm._e(),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "panoramica-status-controls" },
          [
            _vm.showMiglioreOffertaArrow
              ? _c("div", { staticClass: "panoramica-status-transfer-arrow" })
              : _vm._e(),
            _vm._v(" "),
            _vm.showMiglioreOfferta
              ? _c(
                  "v-card",
                  { staticClass: "no-shadow pa-2" },
                  [
                    _c("squadra-offerta", {
                      staticClass: "panoramica-status-offerta",
                      attrs: {
                        offerta: _vm.migliore_offerta.offerta,
                        uid: _vm.migliore_offerta.vincitore,
                        ifNoOfferta: "Nessuna offerta",
                        "crediti-style": "dark",
                        variant: "horizontal",
                        creditiGlow: "",
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.timerTimeLeft !== null
              ? _c("progress-countdown-display", {
                  staticClass: "panoramica-status-timer mx-4",
                  attrs: {
                    time: _vm.timerTime,
                    "time-left": _vm.timerTimeLeft,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _vm.showAssegnaHint
              ? _c(
                  "div",
                  { staticClass: "panoramica-assegna-hint" },
                  [
                    _c(
                      "v-icon",
                      {
                        staticClass: "mr-1 white--text",
                        attrs: { "x-small": "" },
                      },
                      [_vm._v("touch_app")]
                    ),
                    _vm._v(
                      "\n        " + _vm._s(_vm.assegnaHintText) + "\n      "
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _c(_vm.actionsComponent, { tag: "component" }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }